import clsx from 'clsx'

export const Overlay = ({
  block,
  show,
  active,
  bg = 'white',
  opacity = '75',
  cursor = 'wait',
  layer,
  children
}) => {
  const isHidden = active && !block && !show
  const opacityNum = (parseInt(String(opacity), 10) || 75) / 100
  const bgColor = bg === 'dark' ? '#1e2029' : bg

  return (
    <div className={clsx('relative', isHidden && `cursor-${cursor}`)}>
      <div>{children}</div>
      {active && (
        <div
          className={clsx(
            'absolute inset-0 rounded flex items-center justify-center',
            isHidden && 'invisible'
          )}
          style={{ backgroundColor: bgColor, opacity: opacityNum }}
        >
          {layer}
        </div>
      )}
    </div>
  )
}
